import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { sendRequest } from './request.js';
import '../_virtual/_tslib.js';
import PasswordTransaction from './transactions/PasswordTransaction.js';
var getPassword = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(oktaAuth, options) {
    var transaction;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return sendRequest(oktaAuth, {
            url: "/idp/myaccount/password",
            method: 'GET',
            accessToken: options === null || options === void 0 ? void 0 : options.accessToken
          }, PasswordTransaction);
        case 2:
          transaction = _context.sent;
          return _context.abrupt("return", transaction);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getPassword(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var enrollPassword = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(oktaAuth, options) {
    var accessToken, payload, transaction;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          accessToken = options.accessToken, payload = options.payload;
          _context2.next = 3;
          return sendRequest(oktaAuth, {
            url: '/idp/myaccount/password',
            method: 'POST',
            payload: payload,
            accessToken: accessToken
          }, PasswordTransaction);
        case 3:
          transaction = _context2.sent;
          return _context2.abrupt("return", transaction);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function enrollPassword(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var updatePassword = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(oktaAuth, options) {
    var accessToken, payload, transaction;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          accessToken = options.accessToken, payload = options.payload;
          _context3.next = 3;
          return sendRequest(oktaAuth, {
            url: '/idp/myaccount/password',
            method: 'PUT',
            payload: payload,
            accessToken: accessToken
          }, PasswordTransaction);
        case 3:
          transaction = _context3.sent;
          return _context3.abrupt("return", transaction);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function updatePassword(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
var deletePassword = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(oktaAuth, options) {
    var transaction;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return sendRequest(oktaAuth, {
            url: "/idp/myaccount/password",
            method: 'DELETE',
            accessToken: options === null || options === void 0 ? void 0 : options.accessToken
          });
        case 2:
          transaction = _context4.sent;
          return _context4.abrupt("return", transaction);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function deletePassword(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();
export { deletePassword, enrollPassword, getPassword, updatePassword };